export default function switch_map_language(map, language) {
  map &&
    map.setLayoutProperty("country-label", "text-field", [
      "get",
      `name_${language}`,
    ]);
  map.setLayoutProperty("state-label", "text-field", [
    "get",
    `name_${language}`,
  ]);
  map.setLayoutProperty("settlement-major-label", "text-field", [
    "get",
    `name_${language}`,
  ]);
  map.setLayoutProperty("settlement-minor-label", "text-field", [
    "get",
    `name_${language}`,
  ]);
  map.setLayoutProperty("settlement-subdivision-label", "text-field", [
    "get",
    `name_${language}`,
  ]);

  //   map.setLayoutProperty("poi-label", "text-field", ["get", `name_${language}`]);
  //   map.setLayoutProperty("aiport-label", "text-field", [
  //     "get",
  //     `name_${language}`,
  //   ]);

  // map.setLayoutProperty("road-label", "text-field", [
  //   "get",
  //   `name_${language}`,
  // ]);
}
